import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  LEADER_BOARD_FEATURE_KEY,
  LeaderState,
  leaderBoardAdapter,
} from './leader-board.reducer';

// Lookup the 'LeaderBoard' feature state managed by NgRx
export const getLeaderBoardState = createFeatureSelector<LeaderState>(
  LEADER_BOARD_FEATURE_KEY,
);

const { selectAll, selectEntities } = leaderBoardAdapter.getSelectors();

export const getLeaderBoardLoaded = createSelector(
  getLeaderBoardState,
  (state: LeaderState) => state.loaded,
);
export const getLeaderBoardLoading = createSelector(
  getLeaderBoardState,
  (state: LeaderState) => state.loading,
);

export const getLeaderBoardError = createSelector(
  getLeaderBoardState,
  (state: LeaderState) => state.error,
);

export const getAllLeaderBoard = createSelector(
  getLeaderBoardState,
  (state: LeaderState) => selectAll(state),
);
export const getTotalLeaderBoard = createSelector(
  getLeaderBoardState,
  (state: LeaderState) => state.total,
);

export const getLeaderBoardEntities = createSelector(
  getLeaderBoardState,
  (state: LeaderState) => selectEntities(state),
);
